export default __webpack_public_path__ + "static/media/mezcal9.18fc35d3.jpg";